import { format, isSameYear } from 'date-fns';

/**
 * Formats a date into a human-readable string
 * @param date - Date to format
 * @param today - Reference date for determining when to show year (defaults to current date)
 * @returns Formatted date string
 */
export function formatDate(date: Date, today: Date = new Date()): string {
  // Handle invalid dates
  if (!date) {
    return '';
  }

  const sameYear = isSameYear(date, today);

  if (sameYear) {
    // Current year
    return `${format(date, 'MMM d')}`;
  }

  // Different years
  return `${format(date, 'MMM d, yyyy')}`;
}
